module.exports={title:"Eventi",groups:[],emptyEventsContent:""};